import { defaultUrlByType } from 'constants/defaultUrlByType';

export const notifyRouteByType = (type) => {
  const link = defaultUrlByType[type];
  return link ?? '/error';
};
